import { EnvParameters, ParamInfo } from "../shared/env"

export const getParamsCode = (params: EnvParameters) => {
    const keys = Object.keys(params)
    const formatValue = (param: ParamInfo) => param.type=='string' ? `"${param.placeholder}"` : param.placeholder
    const formatItem = (key: string) => {
        const item = params[key]
        const value = formatValue(item)
        return `\t${key}: ${value}`
    }
    return keys.map(formatItem).join(",\n")
}

export const getParamsDict = (env?: EnvParameters) => `params = {
${env!==undefined ? getParamsCode(env) : null}
}`